<template>
  <v-dialog v-model="show" persistent max-width="100">
    <v-container>
      <v-row>
        <v-col class="text-center">
          <v-progress-circular
            :color="tertiaryColor(generalExApplicationEx)"
            indeterminate
          >
          </v-progress-circular>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  name: "Wait",
  props: ["dialog", "generalExApplicationEx"],
  data() {
    return {
      show: true,
    };
  },
  methods: {},
};
</script>

<style>
</style>